module.exports = __webpack_public_path__ + "static/img/8.ba6b7e4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/eng/8.png
// module id = 0abP
// module chunks = 0